import { Theme } from '@emotion/react'
import theme from './theme'

export const defaultTheme = theme as Theme
